import {register} from '../vendor/theme-scripts/theme-sections';
import drawer from '../features/header-mobile-drawer';
import stickyHeader from '../features/header-sticky';
import hoverDisclosure from '../features/header-hover-disclosure';
import {readHeights} from '../globals/height';
import headerTotals from '../features/header-totals';
import searchPopdown from '../features/header-search-popdown';
import popoutSection from '../features/popout';
import headerMobileSliderule from '../features/header-mobile-sliderule';

const selectors = {
  wrapper: '[data-header-wrapper]',
  style: 'data-header-style',
  widthContentWrapper: '[data-takes-space-wrapper]',
  widthContent: '[data-child-takes-space]',
  desktop: '[data-header-desktop]',
  cloneClass: 'js__header__clone',
  showMobileClass: 'js__show__mobile',
  backfill: '[data-header-backfill]',
  transparent: 'data-header-transparent',
  overrideBorder: 'header-override-border',
  firstSectionHasImage: '.main-content > .shopify-section:first-child [data-overlay-header]',
  deadLink: '.navlink[href="#"]',
};

let sections = {};

class Header {
  constructor(el) {
    this.wrapper = el;
    this.style = this.wrapper.dataset.style;
    this.desktop = this.wrapper.querySelector(selectors.desktop);
    this.transparent = this.wrapper.getAttribute(selectors.transparent) !== 'false';
    this.overlayedImages = document.querySelectorAll(selectors.firstSectionHasImage);
    this.deadLinks = document.querySelectorAll(selectors.deadLink);

    this.killDeadLinks();
    if (this.style !== 'drawer' && this.desktop) {
      this.minWidth = this.getMinWidth();
      this.listenWidth();
    }
    this.checkForImage();

    window.dispatchEvent(new Event('resize'));
  }

  unload() {
    document.removeEventListener('theme:resize', this.checkWidth);
  }

  checkForImage() {
    if (this.overlayedImages.length > 0 && this.transparent) {
      // is transparent and has image, overlay the image
      document.querySelector(selectors.backfill).style.display = 'none';
      this.listenOverlay();
    } else {
      this.wrapper.setAttribute(selectors.transparent, false);
    }

    if (this.overlayedImages.length > 0 && !this.transparent) {
      // Have image but not transparent, remove border bottom
      this.wrapper.classList.add(selectors.overrideBorder);
      this.subtractHeaderHeight();
    }
  }

  listenOverlay() {
    document.addEventListener('theme:resize', this.subtractAnnouncementHeight.bind(this));
    this.subtractAnnouncementHeight();
  }

  listenWidth() {
    document.addEventListener('theme:resize', this.checkWidth.bind(this));
    this.checkWidth();
  }

  killDeadLinks() {
    this.deadLinks.forEach((el) => {
      el.onclick = (e) => {
        e.preventDefault();
      };
    });
  }

  subtractAnnouncementHeight() {
    const {windowHeight, announcementHeight, headerHeight} = readHeights();
    this.overlayedImages.forEach((el) => {
      el.style.setProperty('--full-screen', `${windowHeight - announcementHeight}px`);
      el.style.setProperty('--header-padding', `${headerHeight}px`);
      el.classList.add('has-overlay');
    });
  }

  subtractHeaderHeight() {
    const {windowHeight, headerHeight} = readHeights();
    this.overlayedImages.forEach((el) => {
      el.style.setProperty('--full-screen', `${windowHeight - headerHeight}px`);
    });
  }

  checkWidth() {
    if (document.body.clientWidth < this.minWidth) {
      this.wrapper.classList.add(selectors.showMobileClass);
    } else {
      this.wrapper.classList.remove(selectors.showMobileClass);
    }
  }

  getMinWidth() {
    const comparitor = this.wrapper.cloneNode(true);
    comparitor.classList.add(selectors.cloneClass);
    document.body.appendChild(comparitor);
    const widthWrappers = comparitor.querySelectorAll(selectors.widthContentWrapper);
    let minWidth = 0;
    let spaced = 0;

    widthWrappers.forEach((context) => {
      const wideElements = context.querySelectorAll(selectors.widthContent);
      let thisWidth = 0;
      if (wideElements.length === 3) {
        thisWidth = _sumSplitWidths(wideElements);
      } else {
        thisWidth = _sumWidths(wideElements);
      }
      if (thisWidth > minWidth) {
        minWidth = thisWidth;
        spaced = wideElements.length * 20;
      }
    });

    document.body.removeChild(comparitor);
    return minWidth + spaced;
  }
}

function _sumSplitWidths(nodes) {
  let arr = [];
  nodes.forEach((el) => {
    if (el.firstElementChild) {
      arr.push(el.firstElementChild.clientWidth);
    }
  });
  if (arr[0] > arr[2]) {
    arr[2] = arr[0];
  } else {
    arr[0] = arr[2];
  }
  const width = arr.reduce((a, b) => a + b);
  return width;
}
function _sumWidths(nodes) {
  let width = 0;
  nodes.forEach((el) => {
    width += el.clientWidth;
  });
  return width;
}

const header = {
  onLoad() {
    sections = new Header(this.container);
  },
  onUnload: function () {
    if (typeof sections.unload === 'function') {
      sections.unload();
    }
  },
};

register('header', [header, drawer, popoutSection, headerMobileSliderule, stickyHeader, hoverDisclosure, headerTotals, searchPopdown]);
